import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';

export type MenuContext = {
   data: INav;
   handleClose: (ev?: any) => void;
};

export interface TreeViewContext extends MenuContext {
   anchorEl: null | HTMLElement;
   handleClick: (data: INav) => (event: React.MouseEvent<HTMLElement>) => void;
}

export const menuContextDefaultValue = {
   data: {} as INav,
   anchorEl: null,
   handleClose: () => {
      console.error('handleClose is not provided');
   },
   handleClick: (data: INav) => (ev: any) => {
      console.error('handleClick is not provided');
   },
};
export const menuContext = React.createContext<TreeViewContext>(menuContextDefaultValue);
